module.exports = __webpack_public_path__ + "img/waistcircumference.91303af4.jpeg";